import {sort} from "./collections";

const defaultCompares = {
    le: (v1, v2) => v1 <= v2,
    lt: (v1, v2) => v1 <  v2,
    ge: (v1, v2) => v1 >= v2,
};

export const conflict = (r1:{from: number, to: number}, r2:{from: number, to: number}, {ge} = defaultCompares) => {
    r1["r1 is null"];
    r2["r2 is null"];

    if (r1.from != null && r2.to != null && ge(r1.from, r2.to)) {
        return false;
    }
    if (r2.from != null && r1.to != null && ge(r2.from, r1.to)) {
        return false;
    }
    return true;
};

export const intersect = conflict;

export const exclude22 = (oriRanges, holes, compares=defaultCompares) => {
    if (oriRanges == null) {
        return null;
    }

    let ret = [];
    for (const oriRange of oriRanges) {
        ret = [...ret, ...exclude12(oriRange, holes, compares)];
    }
    return ret;
};

export const exclude12 = (oriRange, holes, compares=defaultCompares) => {
    let ret = [oriRange];

    for (const hole of holes) {
        for (let i = ret.length - 1; i > -1; i--) {
            const oriRange = ret[i];

            ret.splice(i, 1, ...exclude11(oriRange, hole, compares));
        }
    }
    return ret;
};


export const exclude11 = (oriRange, hole, c=undefined) => {

    if (!conflict(oriRange, hole, c)) {
        return [oriRange];
    }

    // They have to conflict at some point...

    const {le, ge, lt} = c || defaultCompares;
    if (hole.to == null || (oriRange.to != null && le(oriRange.to, hole.to))) { // hole cover ori to
        if (hole.from != null && (oriRange.from == null || lt(oriRange.from, hole.from))) { // hole does not cover ori from
            // hole cuts later half of oriRange
            return [{...oriRange, from: oriRange.from, to: hole.from}];
        } else {
            // Hole cover all ori -> Vanishes
            return [];
        }
    } else {
        // hole does not cover ori to
        if (hole.from == null || (oriRange.from!= null && ge(oriRange.from, hole.from))) {
            // Hole cuts first half of ori
            return [{...oriRange, from: hole.to, to: oriRange.to}];
        } else {
            // ori range cover hole
            return [
                {...oriRange, from: oriRange.from, to: hole.from},
                {...oriRange, from: hole.to, to: oriRange.to},
            ];
        }
    }
};

export const toRange = (v, length) => {
    if (length > 0) {
        return ({from: v, to: v + length});
    } else {
        return ({from: v, to: v});
    }
};


/**
 * 1-5 + 3-8 = 1-3,3-5,5-8
 * @param ranges
 */
export const fragmentRanges = (ranges) => {
    if (ranges == null) return null;

    let fragmenteds = [];
    for (const range of ranges) {
        fragmenteds = addFraRanges([range], fragmenteds);
    }

    return sortRanges(fragmenteds);
};

const sortRanges = (ranges) => sort<any>(ranges, (r) => r.from??Number.MIN_VALUE);

const addFraRanges = (rsToAdd, fragmenteds) => {

    let rsFra = fragmenteds.slice(0);

    for (let i = rsFra.length - 1; i > -1; i--) {
        const {oris, remains} = addFraRange(rsToAdd, rsFra[i]);

        rsToAdd = remains;
        rsFra.splice(i, 1, ...oris);
    }

    rsFra = [...rsFra, ...rsToAdd];
    return rsFra;
};

const addFraRange = (rsToAdd, rFra) => {
    let oris = [rFra];
    for (let i = oris.length - 1; rsToAdd.length && i > -1; i--) {
        const rO = oris[i];

        let remains = [];
        for (const rToAdd of rsToAdd) {
            if (conflict(rO, rToAdd)) {
                oris.splice(i, 1,
                    ...exclude11(rO, rToAdd),
                    common(rO, rToAdd),
                );
                remains = [...remains, ...exclude11(rToAdd, rO)];
            } else {
                remains.push(rToAdd);
            }
        }
        rsToAdd = remains;
    }
    return {
        oris,
        remains: rsToAdd,
    };
};

const common = (r1, r2) => !conflict(r1, r2) ? null : ({
    from: r2.from == null ? r1.from : r1.from == null ? r2.from : Math.max(r1.from, r2.from),
    to: r2.to == null ? r1.to : r1.to == null ? r2.to :Math.min(r1.to, r2.to),
});
